import React, { forwardRef, ForwardRefRenderFunction, PropsWithChildren } from 'react';

import styles from './styles.css';

const FaqModalLayoutComponent: ForwardRefRenderFunction<HTMLDivElement, PropsWithChildren> = (props, ref) => {
  return (
    <div className={styles['layout']} ref={ref}>
      {props.children}
    </div>
  );
};

export const FaqModalLayout = forwardRef(FaqModalLayoutComponent);
